import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

const StaticSearchAutocompletePopper = styled(Popper)({
    '& .MuiAutocomplete-option:hover, & .MuiAutocomplete-option.Mui-focused': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '& .MuiAutocomplete-paper': {
        background: 'transparent',
        boxShadow: 'none',
        boxSizing: 'border-box',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        maxHeight: '100%',
        minHeight: 0,
        overflow: 'hidden',
    },
    background: '#FFF',
    borderRadius: '4px',
    boxShadow: '0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    zIndex: 2,
});

export default StaticSearchAutocompletePopper;
